// The friend code, remembered per account in the browser.
//
// It was fetched every time the friends page opened — 111 requests a minute at
// the 2026-09-01 peak, for a value that CANNOT change: ensure_friend_code writes
// it once and nothing in the backend ever rewrites it. So the second fetch was
// already answering a question we had asked and had the answer to.
//
// Keyed by uid, because two accounts share a browser more often than you would
// think and a code belongs to a person, not a device. Every access is wrapped:
// storage throws in private windows, and a friend code is not worth an exception
// on the page that shows it.
export const storageKey = (uid) => `friendCode:${uid}`;

export function readCached(uid, storage) {
  if (!uid || !storage) return null;
  try {
    const value = storage.getItem(storageKey(uid));
    return value && value.trim() ? value : null;
  } catch (e) {
    return null;
  }
}

export function remember(uid, code, storage) {
  if (!uid || !code || !storage) return false;
  try {
    storage.setItem(storageKey(uid), code);
    return true;
  } catch (e) {
    return false;
  }
}
